import { Component, inject } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AsyncPipe, CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { RouterOutlet } from '@angular/router';
import { RouterModule } from '@angular/router';
import { JwtService, WorkspaceStateService } from '@core/services';
import { Router } from '@angular/router';

@Component({
    selector: 'app-main',
    templateUrl: './workspace-layout.component.html',
    styleUrls: ['./workspace-layout.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatToolbarModule,
        MatButtonModule,
        MatSidenavModule,
        MatListModule,
        MatIconModule,
        MatTooltipModule,
        AsyncPipe,
        RouterOutlet,
        RouterModule,
    ]
})
export class WorkspaceLayoutComponent {
    
    private breakpointObserver = inject(BreakpointObserver);
    id: string = JwtService.get().payload.uid;

    isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
        .pipe(
            map(result => result.matches),
            shareReplay()
        );

    constructor(
        private router: Router, 
        public ws: WorkspaceStateService) {
    }

    logout() {
        JwtService.clear();
        this.router.navigateByUrl('/login');
    }
}
